var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100 d-none d-md-block hidden" }, [
    _c("div", { staticClass: "h-100 font-weight-bold pr-0 pl-0 ml-0" }, [
      _c(
        "div",
        {
          staticClass: "dropdown border-left d-none d-md-block h-100",
          attrs: { id: "recent-tasks-nav-container" },
        },
        [
          !_vm.isUserRegistered
            ? _c(
                "a",
                {
                  staticClass:
                    "bg-white pr-3 pl-3 dropdown-toggle d-flex flex-column h-100 align-items-center justify-content-center fg-normal fg-main-hover fg-main-dropdown-show position-relative font-weight-bold",
                  attrs: {
                    href: "#",
                    role: "button",
                    "data-toggle": "tooltip",
                    "data-original-title": _vm.bubbleSpeechText,
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "28",
                        height: "30",
                        viewBox: "0 0 28 30",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z",
                          fill: "#000",
                          "fill-opacity": "0.5",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUserRegistered
            ? _c(
                "a",
                {
                  staticClass:
                    "bg-white pr-3 pl-3 dropdown-toggle d-flex flex-column h-100 align-items-center justify-content-center fg-normal fg-main-hover fg-main-dropdown-show position-relative font-weight-bold",
                  attrs: {
                    href: "#",
                    role: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "28",
                        height: "30",
                        viewBox: "0 0 28 30",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z",
                          fill: "currentColor",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUserRegistered
            ? _c(
                "div",
                {
                  staticClass:
                    "main-language-dropdown dropdown-menu dropdown-menu-right dropdown-menu-hover w-100",
                  attrs: { id: "recent-tasks-nav-drop-down" },
                },
                [
                  _vm.tasks.length > 0
                    ? _c(
                        "div",
                        { staticClass: "w-100 d-flex gap-10 flex-column" },
                        [
                          _vm.processingTasks.length > 0
                            ? _c(
                                "div",
                                { staticClass: "d-flex gap-5 flex-column" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("trans")("Processing Tasks")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex gap-5 flex-column" },
                                    _vm._l(
                                      _vm.processingTasks,
                                      function (task, index) {
                                        return index <= 4
                                          ? _c(
                                              "a",
                                              {
                                                key: index,
                                                staticClass:
                                                  "d-flex align-items-center gap-15 single-task-container",
                                                attrs: {
                                                  href: _vm.getJobUrl(task.id),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleReload(
                                                      task.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "time-container",
                                                  },
                                                  [
                                                    _vm._m(0, true),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("formatTime")(
                                                            task.created_at,
                                                            _vm.userLocale
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "operation-container",
                                                  },
                                                  [
                                                    task.sat.operation_icon.includes(
                                                      "<"
                                                    )
                                                      ? _c("span", {
                                                          class:
                                                            "mr-1 icon-30 d-inline-flex align-items-center justify-content-center rounded fg-white p-2 bg-main-" +
                                                            task.sat
                                                              .operation_color,
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              task.sat
                                                                .operation_icon
                                                            ),
                                                          },
                                                        })
                                                      : _c("i", {
                                                          class:
                                                            "icon-30 d-inline-flex flex-shrink-0 align-items-center justify-content-center rounded fg-white far " +
                                                            task.sat
                                                              .operation_icon +
                                                            " bg-main-" +
                                                            task.sat
                                                              .operation_color,
                                                        }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.translateTaskName(
                                                            task.sat
                                                              .readable_operation
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "delete-container",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        $event.preventDefault()
                                                        return _vm.cancelTask(
                                                          task.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "delete-icon",
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "14",
                                                              height: "16",
                                                              viewBox:
                                                                "0 0 14 16",
                                                              fill: "none",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M5.32812 1.6125L4.73438 2.5H9.26562L8.67188 1.6125C8.625 1.54375 8.54688 1.5 8.4625 1.5H5.53438C5.45 1.5 5.37187 1.54062 5.325 1.6125H5.32812ZM9.92188 0.78125L11.0688 2.5H13.25C13.6656 2.5 14 2.83437 14 3.25C14 3.66563 13.6656 4 13.25 4H13V13.5C13 14.8813 11.8813 16 10.5 16H3.5C2.11875 16 1 14.8813 1 13.5V4H0.75C0.334375 4 0 3.66563 0 3.25C0 2.83437 0.334375 2.5 0.75 2.5H2.93125L4.07812 0.778125C4.40312 0.29375 4.95 0 5.53438 0H8.4625C9.04688 0 9.59375 0.29375 9.91875 0.778125L9.92188 0.78125ZM2.5 4V13.5C2.5 14.0531 2.94688 14.5 3.5 14.5H10.5C11.0531 14.5 11.5 14.0531 11.5 13.5V4H2.5ZM5 6V12.5C5 12.775 4.775 13 4.5 13C4.225 13 4 12.775 4 12.5V6C4 5.725 4.225 5.5 4.5 5.5C4.775 5.5 5 5.725 5 6ZM7.5 6V12.5C7.5 12.775 7.275 13 7 13C6.725 13 6.5 12.775 6.5 12.5V6C6.5 5.725 6.725 5.5 7 5.5C7.275 5.5 7.5 5.725 7.5 6ZM10 6V12.5C10 12.775 9.775 13 9.5 13C9.225 13 9 12.775 9 12.5V6C9 5.725 9.225 5.5 9.5 5.5C9.775 5.5 10 5.725 10 6Z",
                                                                fill: "#FF1111",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex gap-5 flex-column" },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm._f("trans")("Recent Tasks"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex gap-5 flex-column" },
                                _vm._l(_vm.tasks, function (task, index) {
                                  return index <= 4
                                    ? _c(
                                        "a",
                                        {
                                          key: index,
                                          staticClass:
                                            "d-flex align-items-center gap-15 single-task-container",
                                          attrs: {
                                            href: _vm.getJobUrl(task.id),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleReload(task.id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "time-container" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "icon-container",
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 14 14",
                                                        fill: "none",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M6.66667 12.3333C8.08115 12.3333 9.43771 11.7713 10.4379 10.7712C11.4381 9.77096 12 8.41441 12 6.99992C12 5.58543 11.4381 4.22888 10.4379 3.22868C9.43771 2.22849 8.08115 1.66659 6.66667 1.66659C5.25218 1.66659 3.89562 2.22849 2.89543 3.22868C1.89524 4.22888 1.33333 5.58543 1.33333 6.99992C1.33333 8.41441 1.89524 9.77096 2.89543 10.7712C3.89562 11.7713 5.25218 12.3333 6.66667 12.3333ZM6.66667 0.333252C7.54215 0.333252 8.40905 0.50569 9.21789 0.840722C10.0267 1.17575 10.7617 1.66682 11.3807 2.28587C11.9998 2.90493 12.4908 3.63986 12.8259 4.4487C13.1609 5.25753 13.3333 6.12444 13.3333 6.99992C13.3333 8.76803 12.631 10.4637 11.3807 11.714C10.1305 12.9642 8.43478 13.6666 6.66667 13.6666C2.98 13.6666 0 10.6666 0 6.99992C0 5.23181 0.702379 3.53612 1.95262 2.28587C3.20286 1.03563 4.89856 0.333252 6.66667 0.333252ZM7 3.66659V7.16659L10 8.94659L9.5 9.76659L6 7.66659V3.66659H7Z",
                                                          fill: "black",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatTime")(
                                                      task.created_at,
                                                      _vm.userLocale
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "operation-container",
                                            },
                                            [
                                              task.sat.operation_icon.includes(
                                                "<"
                                              )
                                                ? _c("span", {
                                                    class:
                                                      "icon-30 d-inline-flex align-items-center justify-content-center rounded fg-white bg-main-" +
                                                      task.sat.operation_color,
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        task.sat.operation_icon
                                                      ),
                                                    },
                                                  })
                                                : _c("i", {
                                                    class:
                                                      "icon-30 d-inline-flex flex-shrink-0 align-items-center justify-content-center rounded fg-white far " +
                                                      task.sat.operation_icon +
                                                      " bg-main-" +
                                                      task.sat.operation_color,
                                                  }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.translateTaskName(
                                                      task.sat
                                                        .readable_operation
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "status-icon" },
                                            [
                                              task?.status?.code === "completed"
                                                ? _c("i", {
                                                    staticClass: "far fa-check",
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              task?.status?.code ===
                                              "processing"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa fa-spin btn-loading-animation lh-small",
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              task?.status?.code === "failed"
                                                ? _c("i", {
                                                    staticClass: "fa fa-times",
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn w-100 all-tasks-btn text-white",
                              attrs: { href: _vm.linkRecentTasks },
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(_vm._f("trans")("All Tasks"))),
                              ]),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "fa fa-arrow-right lh-inherit ml-1 py-1",
                              }),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "w-100 d-flex gap-20 flex-column" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex gap-10 flex-column" },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm._f("trans")("Recent Tasks"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "alert-info d-flex align-items-center no-task-container",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm._f("trans")("No Recent Tasks"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn w-100 all-tasks-btn text-white",
                              attrs: { href: _vm.linkRecentTasks },
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(_vm._f("trans")("All Tasks"))),
                              ]),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "fa fa-arrow-right lh-inherit ml-1 py-1",
                              }),
                            ]
                          ),
                        ]
                      ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("div", { staticClass: "d-flex justify-content-center" }, [
        _c("i", { staticClass: "fa fa-spin btn-loading-animation lh-small" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }